import { styled, Button, ButtonProps} from '@mui/material'

// Generic button UI component intended for wide usage in future sprints

 const StyledButton = styled(Button)(({theme}) => ({
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }))

  const ActionButton = ({variant, ...props }: ButtonProps) => (
    <StyledButton variant='contained' {...props} />
  );
  

  export default ActionButton